<div
  id="phenological-images"
  [class.has-gallery-error]="mode === 'gallery' && galleryWasThereAnError && galleryItems.length === 0"
  [class.has-gallery-append-error]="mode === 'gallery' && galleryWasThereAnError && galleryItems.length > 0">
  @if (mode === 'gallery') {
    @if (galleryLoading) {
      <div class="photos-fill">
        <p-skeleton width="100%" height="100%" />
      </div>
    } @else {
      <dk-image-gallery
        [groups]="galleryGroups"
        [periodStart]="galleryPeriodStart"
        [periodEnd]="galleryPeriodEnd"
        [hasMore]="galleryHasMore"
        [isLoadingMore]="galleryIsLoadingMore"
        [emptyMessageKey]="
          !galleryWasThereAnError && galleryItems.length === 0
            ? galleryPeriodStart && galleryPeriodEnd
              ? 'doktar_app.services.crop_monitoring.phenology.no_photos_in_period'
              : 'doktar_app.services.crop_monitoring.phenology.no_photos'
            : ''
        "
        [clearActionKey]="
          galleryIsCustomPeriod ? 'doktar_app.services.crop_monitoring.phenology.back_to_rotation_period' : ''
        "
        (clearPeriod)="clearGalleryPeriod()"
        (changePeriod)="openGalleryPeriodDialog()"
        (loadMore)="loadMoreGallery()"
        (itemSelected)="onGalleryItemSelected($event)"
        (back)="closeGallery()" />
      @if (galleryWasThereAnError) {
        <div class="px-3 centerise">
          <app-weather-soil-pest-error-container
            [selectedPlantation]="selectedPlantation"
            [selectedDevice]="selectedPhenology"
            (retry)="retryGallery()" />
        </div>
      }
    }
  } @else {
    <div class="photos-title-row">
      <p class="title" [title]="'doktar_app.services.crop_monitoring.phenology.photos_from_phenology_camera' | translate">
        {{ 'doktar_app.services.crop_monitoring.phenology.photos_from_phenology_camera' | translate }}
      </p>
      @if ((weatherSoilPestChangeDeviceService.phenologyDevices$ | async)?.length > 0) {
        <div class="photos-header-actions">
          @let dataSourceLabel =
            ('doktar_app.services.weather_soil_and_pest.data_source' | translate) +
            (selectedPhenology?.name ? ': ' + selectedPhenology.name : '');
          <dk-button
            class="data-source-button"
            data-testid="data-source"
            severity="secondary"
            [label]="dataSourceLabel"
            [attr.title]="dataSourceLabel"
            (onClick)="onClickChangeDeviceBtn($event)">
            <i class="ph ph-caret-down data-source-caret" aria-hidden="true"></i>
          </dk-button>

          <button
            type="button"
            class="gallery-button"
            data-testid="open-gallery"
            [disabled]="!phenologicalImagesResponse"
            [pTooltip]="'doktar_app.services.crop_monitoring.phenology.go_to_gallery' | translate"
            (click)="openGallery()">
            <i class="ph ph-image"></i>
          </button>
        </div>
      }
    </div>
    @if ((weatherSoilPestChangeDeviceService.phenologyDevices$ | async)?.length > 0) {
      <!-- Outside the header row: its host is a flex item of no width that would double the gap. -->
      <app-weather-soil-pest-change-device-popover [deviceLineCode]="deviceLineCodesEnum.PHENOLOGY" />
    }
    @if (!loading) {
      @if ((weatherSoilPestChangeDeviceService.phenologyDevices$ | async)?.length > 0) {
        @if (!wasThereAnError) {
          @if (phenologicalImagesResponse?.images?.items?.length > 0) {
            <p class="week-label">
              {{
                phenologicalImagesResponse.currentWeek
                  ? ('doktar_app.common.week_x' | translate: { arg1: phenologicalImagesResponse.currentWeek })
                  : ''
              }}
            </p>
            <div class="slider">
              <div class="slides-container" #slidesContainerEl>
                <swiper-container
                  #swiperContainer
                  navigation="false"
                  pagination="true"
                  scrollbar="false"
                  space-between="15"
                  slides-per-view="auto"
                  slides-per-group="1"
                  centered-slides="false"
                  loop="false">
                  @for (item of phenologicalImagesResponse?.images?.items ?? []; track item.imageId) {
                    <swiper-slide>
                      <button type="button" class="slide" (click)="onStripCardSelected(item)">
                        <img [src]="item.imageUrl" alt="" />
                        <span class="image-date-time">
                          {{
                            item.captureDateTime | luxonFormat: 'd LLLL yyyy HH:mm' : 'UTC' + selectedPlantation.offSet
                          }}
                        </span>
                      </button>
                    </swiper-slide>
                  }
                </swiper-container>
              </div>

              <i
                class="ph-fill ph-caret-circle-left back-slide-icon"
                [ngClass]="{ disabled: activeSlideIndex === 0 }"
                (click)="goToPreviousSlide()"></i>
              @if (activeSlideIndex < totalCount - 1) {
                @if (!loadMoreLoading) {
                  <i class="ph-fill ph-caret-circle-right next-slide-icon" (click)="goToNextSlide()"></i>
                } @else {
                  <div class="spinner-div">
                    <i class="pi pi-spin pi-spinner-dotted"></i>
                  </div>
                }
              }
            </div>
          } @else {
            <div class="px-3 centerise">
              <app-weather-soil-pest-nodata-container />
            </div>
          }
        } @else {
          <div class="px-3 centerise">
            <app-weather-soil-pest-error-container
              [selectedPlantation]="selectedPlantation"
              (retry)="getPhenologicalImages()" />
          </div>
        }
      } @else {
        <!-- <app-no-phenology-device-container /> -->
        <app-weather-soil-pest-add-confirm-device
          deviceLineName="phenocam"
          wrongDeviceMessage="Only phenology devices can be added!" />
      }
    } @else {
      <div class="photos-fill">
        <p-skeleton width="100%" height="100%" />
      </div>
    }
  }
</div>

<ng-template #zoomFooter let-item>
  <div class="zoom-footer">
    <p data-testid="zoom-week">{{ zoomWeekLabel(item) }}</p>
    <p data-testid="zoom-captured-at">{{ zoomCapturedAt(item) }}</p>
  </div>
</ng-template>
